export default {
  "trigger": "Score par voix",
  "examplesButton": "Que puis-je dire ?",
  "example": "“ {first} un sur, {second} birdie”",
  "title": "SCORE VOCAL",
  "states": {
    "requesting_permission": "Préparer le micro...",
    "listening": "Écoute...",
    "processing_recording": "Enregistrement de traitement...",
    "transcribing": "Tracrire...",
    "interpreting": "Comprendre vos scores...",
    "review": "Vérifiez les scores",
    "error": "Signification vocale"
  },
  "cancel": "Annuler",
  "done": "Terminé",
  "heard": "Heard: “ {transcript} ”",
  "strokes": "AVC",
  "decrease": "Diminution du score proposé {name}",
  "increase": "Augmentation du score proposé de {name}",
  "labels": {
    "holeInOne": "Trou en un",
    "albatross": "Albatros",
    "eagle": "Aigle",
    "birdie": "Oiseau.",
    "par": "Par",
    "bogey": "Bogey.",
    "doubleBogey": "Double bogey",
    "tripleBogey": "Triple corps"
  },
  "correction": "Correction entendue : “ {phrase} ”",
  "repair": "Confirmer l'interprétation: “ {original} ” a été compris comme “ {replacement} ”.",
  "repairSuggestion": "Possible interprétation: “ {original} ” peut signifier “ {replacement} ”. Confirmer les coups réels ci-dessous.",
  "subset": "Seuls les scores compris seront appliqués. Les entrées non résolues ne seront pas sauvegardées.",
  "retry": "Réessayer",
  "apply": "Appliquer les scores",
  "applySubset": "Appliquer les scores compris",
  "manual": "Utiliser le pointage manuel",
  "clarification": "Besoin d ' éclaircissements",
  "player": "Joueur",
  "choosePlayer": "Choisissez un joueur",
  "gross": "Blessures brutes",
  "confirmEntry": "Confirmez ce score",
  "skip": "Laissez cette entrée.",
  "errors": {
    "interpretationFailure": "Nous ne pouvions pas interpréter ces partitions. Essayez de nouveau ou utilisez la notation manuelle.",
    "unavailable": "La correction vocale n'est pas disponible en ce moment. S'il vous plaît utiliser la notation manuelle.",
    "microphone_permission_denied": "L'accès au microphone est désactivé pour Privana . Paramètres de périphériques ouverts, activer Microphone pour Privana , puis essayez à nouveau.",
    "microphone_unavailable": "Nous ne pouvions pas accéder à votre microphone. Essayez de nouveau.",
    "media_recorder_unavailable": "L’enregistrement vocal n’est pas pris en charge sur cet appareil.",
    "empty_audio": "Nous n’avons pas pris de son.",
    "unsupported_audio": "Ce dispositif a enregistré un format audio non supporté.",
    "upload_failed": "Nous ne pouvions pas envoyer cet enregistrement. Vérifiez votre connexion et essayez à nouveau.",
    "no_speech": "Nous n’avons pas entendu de discours.",
    "transcription_failed": "Nous ne pouvions pas transcrire cela. Essayez encore.",
    "voice_timeout": "La correction vocale a pris trop de temps. Essayez de nouveau ou utilisez la notation manuelle.",
    "recording_failed": "Nous ne pouvions pas enregistrer votre voix. Essayez de nouveau.",
    "saveFailure": "Certains scores n'ont pas pu être filetés. Gardez cet avis ouvert et essayez à nouveau."
  }
}
